import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo.png'
import _imports_1 from '../../assets/img/title.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-359e05ec")

_pushScopeId("data-v-359e05ec")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "title",
  src: _imports_1
}, null, -1)
const _hoisted_4 = { class: "online" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关于我们")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_top_bar = _resolveComponent("top-bar")
  const _component_head_bar = _resolveComponent("head-bar")
  const _component_el_header = _resolveComponent("el-header")
  const _component_bulletin_bar = _resolveComponent("bulletin-bar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_online = _resolveComponent("online")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withId(() => [
        _createVNode(_component_top_bar),
        _createVNode(_component_el_header, { height: "60px" }, {
          default: _withId(() => [
            _createVNode("span", null, [
              _hoisted_2,
              _hoisted_3,
              _createVNode(_component_head_bar)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_bulletin_bar),
        _createVNode(_component_el_main, null, {
          default: _withId(() => [
            _createVNode(_component_router_view, null, {
              default: _withId(({ Component }) => [
                _createVNode(_Transition, { mode: "out-in" }, {
                  default: _withId(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_online)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})